var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{staticClass:"py-2 text-center",attrs:{"variant":_vm.variant,"show":""}},[_c('b-spinner',{attrs:{"variant":_vm.variant,"label":"Spinning"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.message)?_c('span',{staticClass:"ops-text font-weight-bolder",domProps:{"textContent":_vm._s(_vm.message)}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }